const iconPending = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" class="icon icon-order-status--pending">
  <path d="M4 4L20 20" stroke="currentColor"/>
  <path d="M4 20L20 4" stroke="currentColor"/>
</svg>`;
const iconComplete = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" class="icon icon-order-status--complete">
  <path d="M6 12.1613L10.25 16L18 9" stroke="currentColor" stroke-width="2"/>
  <circle cx="12" cy="12" r="11" stroke="currentColor" stroke-width="2"/>
</svg>`;
const iconDelivery = `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
  <path d="M21.9102 22.2634L12.9102 22.2634" stroke="currentColor" stroke-miterlimit="10" stroke-linecap="round"/>
  <path d="M27.3022 22.2632H29.1812V16.558L24.4755 11.6958H20.625V11.7027V22.2114" stroke="currentColor" stroke-miterlimit="10"/>
  <path d="M29.1816 16.5581H20.625" stroke="currentColor" stroke-miterlimit="10"/>
  <path d="M8.58418 20.2792C9.58704 19.2762 11.2129 19.2762 12.2158 20.2792C13.2186 21.282 13.2186 22.908 12.2158 23.9109C11.2129 24.9138 9.58704 24.9138 8.58418 23.9109C7.58132 22.908 7.58132 21.282 8.58418 20.2792Z" stroke="currentColor" stroke-miterlimit="10"/>
  <path d="M22.9005 20.2792C23.9034 19.2762 25.5293 19.2762 26.5321 20.2792C27.535 21.282 27.535 22.908 26.5321 23.9109C25.5293 24.9138 23.9034 24.9138 22.9005 23.9109C21.8977 22.908 21.8977 21.282 22.9005 20.2792Z" stroke="currentColor" stroke-miterlimit="10"/>
  <path d="M10.1017 10.6184H2.96875" stroke="currentColor" stroke-miterlimit="10"/>
  <path d="M9.50024 13.9004H1.82031" stroke="currentColor" stroke-miterlimit="10"/>
  <path d="M12.7207 22.2H20.4413V7H5.00006V22.2H7.8953" stroke="currentColor"/>
</svg>`;

class OrderTracking extends HTMLElement {
  constructor() {
    super();
    this.btnOrderStatusMenu = this.querySelector('#order-status-menu');
    this.btnCheckOrderStatus = this.querySelector('#check-order-status-button');
    this.form = this.btnCheckOrderStatus.closest('form');
    this.detail = this.querySelector('#order-status-details');

    this.btnCheckOrderStatus.addEventListener('click', this.onCheckOrderStatusClicked.bind(this));
    document.addEventListener('click', this.toggleDropdown.bind(this));
  }

  toggleDropdown(e) {
    if (e.target === this.btnOrderStatusMenu) {
      this.btnOrderStatusMenu.classList.toggle('open');
    } else if (!this.btnOrderStatusMenu.contains(e.target)) {
      this.btnOrderStatusMenu.classList.remove('open');
    }
  }

  enableLoading() {
    this.btnCheckOrderStatus.disabled = true;
    this.btnCheckOrderStatus.classList.add('loading');
    this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
  }

  disableLoading() {
    this.btnCheckOrderStatus.disabled = false;
    this.btnCheckOrderStatus.classList.remove('loading');
    this.querySelector('.loading-overlay__spinner').classList.add('hidden');
  }

  validate() {
    if (this.form.checkValidity()) return true;

    this.form.reportValidity();
    return false;
  }

  onCheckOrderStatusClicked(e) {
    e.preventDefault();
    this.validate();
    this.renderTrackingInfo();
  }

  clearTrackingInfo() {
    this.detail.style.display = 'none';
    this.detail.innerHTML = '';
  }

  renderTrackingInfo() {
    this.clearTrackingInfo();
    this.enableLoading();

    const body = JSON.stringify({
      orderNumber: this.querySelector('#orderNumberInput').value,
      email: this.querySelector('#orderEmailInput').value,
    });

    fetch(`${routes.order_tracking_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => response.json())
      .then(({ message }) => {
        if (typeof message === 'undefined' || message === '') {
          this.detail.innerHTML = this.dataset.notFoundText;
          this.detail.style.display = 'block';
          return;
        }

        const fragment = new DOMParser().parseFromString(message, 'text/html');
        const trackingElement = fragment.querySelector('li > a');
        const trackingStatuses = fragment.querySelectorAll('li:not(:last-child)');
        trackingStatuses.forEach((status) => {
          const icon = status.classList.contains('complete') ? iconComplete : iconPending;
          status.insertAdjacentHTML('afterbegin', icon);
        });
        trackingElement.classList.add(
          'button',
          'button--small',
          'button--full-width',
          'button--secondary',
          'track-order-button'
        );
        trackingElement.setAttribute('aria-label', trackingElement.textContent);
        trackingElement.textContent = this.dataset.trackingText;
        trackingElement.insertAdjacentHTML('afterbegin', iconDelivery);
        this.detail.innerHTML = fragment.body.innerHTML;
        this.detail.style.display = 'block';
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.disableLoading();
      });
  }
}

customElements.define('order-tracking', OrderTracking);
